
import React from 'react';

import Image from 'next/image';

import {
  Box,
  ImageList,
  ImageListItem,
  NoSsr,
} from '@mui/material';

import SimpleReactLightbox, { SRLWrapper, useLightbox } from "simple-react-lightbox";


const Photos = ({ images, businessName }) => {
  
  const { openLightbox } = useLightbox();

  const photos = images.map(i => ({
    src: i.image + '?w=1000',
    caption: businessName,
  }));

  return (
    <>
      <Box
        sx={{
          display: 'flex',
          flexWrap: 'wrap',
          justifyContent: 'space-around',
          overflow: 'hidden',
          bgcolor: 'background.paper',
          cursor: 'pointer',
          '&:hover': {
            background: '#ededed',
          },
        }}
      >
        <ImageList
          rowHeight={200}
          cols={3}
          sx={{
            width: '100%',
          }}
        >
          {images.slice(0, 3).map((tile, index) => (
            <ImageListItem
              key={tile.id}
              sx={{ position: 'relative' }}
              onClick={() => openLightbox(index)}
            >
              <Image
                src={tile.image}
                alt={businessName + ` photo ${tile.id}`}
                height={200}
                width={240}
                objectFit="cover"
              />
            </ImageListItem>
          ))}
        </ImageList>
      </Box>
      <NoSsr>
        <SRLWrapper
          elements={photos}
          options={{
            buttons: {
              showAutoplayButton: false,
              showDownloadButton: false,
              showFullscreenButton: false,
              showThumbnailsButton: false,
            }
          }}
        />
      </NoSsr>
    </>
  );
};


const DesktopPhotos = ({ businessName, images }) => (
  <SimpleReactLightbox>
    <Photos businessName={businessName} images={images} />
  </SimpleReactLightbox>
);


export default DesktopPhotos;
